import { Component, OnInit } from "@angular/core";
import { ProductService } from "../../../shared/services/product.service";
import { BannerService } from "../../../shared/services/banner.service";
import { ProductSlider } from "../../../shared/data/slider";
import { Product } from "../../../shared/classes/product";
import { AppService } from "../../../app.service";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-fashion-one",
  templateUrl: "./fashion-one.component.html",
  styleUrls: ["./fashion-one.component.scss"],
})
export class FashionOneComponent implements OnInit {
  public products: Product[] = [];
  public productCollections: any[] = [];
  public active;
  public banners: any[] = [];

  constructor(
    public productService: ProductService,
    private appService: AppService,
    public bannerService: BannerService,
    config: NgbCarouselConfig
  ) {
    config.interval = 3000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = true;

    this.productService.getProducts.subscribe((response) => {
      this.products = response.filter((item) => item.type == "fashion");

      this.products.filter((item) => {
        item.collection.filter((collection) => {
          const index = this.productCollections.indexOf(collection);
          if (index === -1) this.productCollections.push(collection);
        });
      });
    });
  }

  ngOnInit(): void {
    this.listar();
  }

  listar() {
    this.bannerService.listarBanner().subscribe({
      next: (data: any) => {
        this.banners = data.map((banner) => ({
          ...banner,
          linkDirecionamento: this.addHttpPrefix(banner.linkDirecionamento),
        }));
      },
      error: (err: any) => this.appService.trataErro(err),
    });
  }

  addHttpPrefix(link: string): string {
    if (link && !/^(?:f|ht)tps?:\/\//.test(link)) {
      return "https://" + link;
    }
    return link;
  }

  // Collection banner
  public collections = [
    {
      image: "assets/images/collection/fashion/1.jpg",
      save: "Desconto 50%",
      title: "men",
    },
    {
      image: "assets/images/collection/fashion/2.jpg",
      save: "save 50%",
      title: "women",
    },
  ];

  // Blog
  public blog = [
    {
      image: "assets/images/blog/1.jpg",
      date: "25 January 2023",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/2.jpg",
      date: "26 January 2023",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/3.jpg",
      date: "27 January 2023",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/4.jpg",
      date: "28 January 2023",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
  ];

  // Logo
  public logo = [
    {
      image: "assets/images/logos/1.png",
    },
    {
      image: "assets/images/logos/2.png",
    },
    {
      image: "assets/images/logos/3.png",
    },
    {
      image: "assets/images/logos/4.png",
    },
    {
      image: "assets/images/logos/5.png",
    },
    {
      image: "assets/images/logos/6.png",
    },
    {
      image: "assets/images/logos/7.png",
    },
    {
      image: "assets/images/logos/8.png",
    },
  ];

  // Product Tab collection
  getCollectionProducts(collection) {
    return this.products.filter((item) => {
      if (item.collection.find((i) => i === collection)) {
        return item;
      }
    });
  }
}
